<template>
  <div class="home">
    <div id="container">
      <div id="truck">
        <div class="body"></div>
        <div class="detailing"></div>
        <div class="under"></div>
        <div class="wheel1"></div>
        <div class="wheel2"></div>
        <div class="bumper"></div>
        <div class="frontlight"></div>
        <div class="frontwindow"></div>
        <div class="frontdoor">
          <div class="doorwindow"></div>
        </div>
        <p class="white left">
          <!-- <span>FREE YOUR HANDS</span><br /><span class="lower"
            >& Abstraction</span -->
          <span>游戏领域</span><br /><span class="lower">& 业务仿真</span>
        </p>
        <p class="white right" style="left: 320px; top: 274px">
          <span>SaaS</span><br /><span class="lower">& PaaS</span>
        </p>
        <!-- <div class="cookie darkchocolate">
          <span class="chip"></span>
        </div>
        <div class="cookie sugar">
          <span class="sprinkle"></span>
          <span class="sprinkle"></span>
          <span class="sprinkle"></span>
        </div>

        <div class="cookie chocolatechip">
          <span class="chip"></span>
          <span class="chip"></span>
          <span class="chip"></span>
        </div> -->
        <p class="white right">
          <!-- <span>LATEST INFORMATION</span><br /><span class="lower">PUSH</span> -->
          <span>最新信息资讯</span><br /><span class="lower">推送</span>
        </p>
        <div class="menu left">
          <p class="title">BUILD YOUR</p>
          <p class="subtitle">New program</p>
          <div class="bottom-cookie"></div>
          <div class="icecream">
            <div class="vanilla"></div>
            <div class="chocolate"></div>
            <div class="strawberry"></div>
          </div>
          <div class="top-cookie"></div>
        </div>
        <div class="windowhole">
          <div class="window">
            <p class="logo-1">欢迎光临 <span>oopvr</span></p>
            <p class="logo-3-shadow">
              <span>R</span><span>U</span><span>N</span>code<span>M</span
              ><span>A</span><span>N</span>
            </p>
            <p class="logo-3">
              <span>R</span><span>U</span><span>N</span>code<span>M</span
              ><span>A</span><span>N</span>
            </p>
            <p class="logo-2">&</p>
          </div>
        </div>
        <div class="menu right">
          <span class="cookies">
            <p class="title">SERVER</p>
            <p class="subtitle">SPRING CLOUD！</p>
          </span>
          <span class="icecream">
            <p class="title">VIEW</p>
            <p class="subtitle">VUE ANT！</p>
          </span>
          <span class="milk">
            <p class="title">READY</p>
            <p class="subtitle">REACT！</p>
          </span>
        </div>
        <div class="shadow"></div>
      </div>
    </div>
    <!-- <a-carousel autoplay>
      <div>
       <img src="http://oopvr.oss-cn-shenzhen.aliyuncs.com/ClientUser/1_/static/jpg/37635ff4-1dd9-4eb1-b11e-97c79fef715c.jpg" />
       <h3>1</h3>
      </div>
      <div><h3>2</h3></div>
      <div><h3>3</h3></div>
      <div><h3>4</h3></div>
    </a-carousel> -->
    <!-- <Floorplan/> -->
    <!-- <h4>{{ name }}</h4>
    <h3>{{ msg }}</h3>
    <h2>{{ dataLook }}</h2>
    <h1>{{ oopvrs }}</h1> -->

    <Marvellous />
  </div>
</template>

<script>
// import Floorplan from './homebooth/Floorplan'
// import storycontainer from "@/components/column/cloudstorys/storycontainer.vue";
import marvellous from "@/components/bottonconfig/marvellous.vue";
export default {
  name: "index",
  data() {
    return {
      name: "首页位置",
      msg: "待更新",
      dataLook: "有好的想法可以联系我喔！",
      oopvrs: "微信:OOPVR_97",
    };
  },
  created() {
    // console.log(this.$options.filters["dataOOPvr"](this.oopvrs));
  },
  methods: {},
  components: {
    Marvellous: marvellous,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.home {
  // width: 100%;

  #container {
  height: 450px;
  width: 800px;
  position: absolute;
  top: calc(40% - 200px);
  left: calc(50% - 500px);
  p {
    font-family: "Kalam", cursive;
    font-weight: bold;
    margin: 0;
  }
}

#truck {
  width: 100%;
  height: 100%;
  position: relative;
  animation: slidein 2.5s ease 1s;
}

@keyframes slidein {
  from {
    margin-left: -500px;
  }
  to {
    margin-left: 0;
  }
}

*::before,
*::after {
  content: "";
  position: absolute;
}

.body {
  position: absolute;
  background-color: #6acff5;
  height: 353px;
  width: 761px;
  left: 52px;
  top: 26px;
  border-radius: 20px;
  &::before {
    width: 59px;
    height: 220px;
    background-color: inherit;
    right: -24px;
    transform: rotate(-17deg);
    border-radius: inherit;
  }
  &::after {
    width: 160px;
    height: 160px;
    border-radius: inherit;
    right: -108px;
    bottom: 0;
    background-color: inherit;
  }
}

.detailing {
  background-color: #91dcf9;
  position: absolute;
  height: 22px;
  width: 773px;
  left: 48px;
  top: 26px;
  border-radius: 20px 20px 5px 5px;
  &::after {
    height: 10px;
    width: 600px;
    left: 20px;
    top: 218px;
    background-color: inherit;
    border-radius: 13px;
    box-shadow: inset 0 -3px 5px 0px #6fbedc;
  }
}

.under {
  background-color: #333;
  position: absolute;
  height: 30px;
  width: 869px;
  left: 52px;
  top: 349px;
  border-radius: 0 0 20px 20px;
}

.wheel1,
.wheel2 {
  position: absolute;
  height: 75px;
  width: 150px;
  background-color: #333;
  left: 130px;
  top: 304px;
  border-radius: 75px 75px 0 0;
}

.wheel2 {
  left: 711px;
}

.wheel1::before,
.wheel2::before {
  height: 130px;
  width: 130px;
  background-color: black;
  border-radius: 100%;
  top: 10px;
  left: 10px;
}

.wheel1::after,
.wheel2::after {
  height: 50px;
  width: 50px;
  left: calc(50% - 25px);
  top: 47px;
  background-color: #e0dddd;
  border-radius: 100%;
}

.bumper {
  position: absolute;
  height: 50px;
  width: 35px;
  background-color: #e0dddd;
  top: 309px;
  left: 898px;
  border-radius: 11px;
  &::after {
    height: 25px;
    width: 25px;
    background-color: inherit;
    left: -77px;
    top: -74px;
    border-radius: 100%;
  }
}

.frontlight {
  position: absolute;
  height: 60px;
  width: 20px;
  background-color: #333;
  left: 901px;
  top: 235px;
  border-radius: 11px 0 0 11px;
  &::before {
    height: 50px;
    width: 22px;
    background-color: #f7eaa9;
    left: 6px;
    top: 5px;
    border-radius: 9px;
  }
}

.frontwindow {
  position: absolute;
  background-color: gray;
  height: 115px;
  width: 48px;
  top: 70px;
  left: 796px;
  border-radius: 5px;
  clip-path: polygon(0 0, 31% 0, 100% 100%, 0% 100%);
  background: linear-gradient(
    -21deg,
    #5f5f5f,
    #5f5f5f 39%,
    #868686 40%,
    #868686 65%,
    #5f5f5f 66%,
    #5f5f5f
  );
}

.frontdoor {
  position: absolute;
  height: 221px;
  width: 101px;
  border: 4px solid #3333;
  left: 678px;
  top: 70px;
  &::after {
    height: 28px;
    width: 8px;
    left: 89px;
    top: 105px;
    border-radius: 9px;
    background-color: #3333;
  }
  .doorwindow {
    position: absolute;
    background-color: gray;
    height: 78px;
    width: 80px;
    left: 10px;
    top: 10px;
    border-radius: 9px 9px 0 0;
    background: linear-gradient(
      -21deg,
      #5f5f5f,
      #5f5f5f 39%,
      #868686 40%,
      #868686 65%,
      #5f5f5f 66%,
      #5f5f5f
    );
  }
}

p.white {
  font-family: "Kalam", cursive;
  position: absolute;
  top: 256px;
  left: 72px;
  font-size: 18px;
  color: white;
  text-shadow: 2px 2px black;
  &.right {
    left: 505px;
  }
  .lower {
    font-size: 31px;
    top: 12px;
    left: 9px;
    position: absolute;
    white-space: nowrap;
  }
}

.cookie {
  position: absolute;
  top: 274px;
  height: 75px;
  width: 150px;
  border-radius: 150px 150px 0 0;
  .chip {
    position: absolute;
    background-color: #734328;
    height: 21px;
    width: 21px;
  }
}

.chocolatechip {
  left: 278px;
  background-color: #e4c38c;
  box-shadow: inset -5px 3px 7px -3px #b18c4f;
  .chip:nth-of-type(1) {
    top: 19px;
    left: 65px;
    clip-path: polygon(17% 0, 79% 26%, 100% 50%, 75% 100%, 25% 100%, 0% 50%);
  }
  .chip:nth-of-type(2) {
    top: 41px;
    left: 28px;
    clip-path: polygon(23% 16%, 95% 6%, 100% 50%, 65% 100%, 27% 80%, 0% 50%);
  }
  .chip:nth-of-type(3) {
    top: 44px;
    left: 101px;
    clip-path: polygon(28% 0, 95% 6%, 79% 41%, 78% 89%, 22% 100%, 0 65%);
  }
}

.darkchocolate {
  left: 382px;
  background-color: #52360c;
  box-shadow: inset -5px 3px 7px -3px #2d1c03;
  .chip {
    background-color: #2d1d04;
    left: 106px;
    top: 30px;
    clip-path: polygon(17% 0, 79% 26%, 100% 50%, 75% 100%, 25% 100%, 0% 50%);
  }
}

.sugar {
  left: 330px;
  background-color: #f7e2bf;
  box-shadow: inset -5px 3px 7px -3px #c3a879;
  .sprinkle {
    position: absolute;
    top: 22px;
    left: 89px;
    height: 5px;
    width: 21px;
    background-color: #e84040;
    transform: rotate(7deg);
    border-radius: 27px;
    &:nth-of-type(2) {
      top: 46px;
      left: 82px;
      background-color: #ffc064;
      tranform: rotate(-16deg);
    }
    &:nth-of-type(3) {
      top: 62px;
      left: 106px;
      background-color: #7878d2;
      transform: rotate(-52deg);
    }
  }
}

.menu {
  position: absolute;
  top: 55px;
  left: 103px;
  height: 148px;
  width: 98px;
  background-color: #ffda57;
  border: 8px solid #232323;
  box-shadow: 0px 3px 4px 1px #0005;
  &.right {
    left: 552px;
  }
}

.windowhole {
  position: absolute;
  top: 47px;
  left: 230px;
  height: 172px;
  width: 293px;
  background-color: #3c3c3c;
  border: 8px solid #91dcf9;
}

.window {
  position: absolute;
  height: 130px;
  width: 293px;
  background-color: #41c0ef;
  border-bottom: 5px solid #318eb1;
}

.logo-1 {
  position: absolute;
  top: 11px;
  left: 61px;
  font-size: 33px;
  font-family: "Tienne", serif;
  color: #fbd157;
  text-shadow: 2px 2px #c78302;
  span {
    position: absolute;
    font-size: 49px;
    left: -25px;
    top: 21px;
  }
}

.logo-2 {
  position: absolute;
  top: 70px;
  left: 140px;
  font-size: 29px;
  font-weight: lighter;
  color: #dc3333;
}

.logo-3,
.logo-3-shadow {
  position: absolute;
  font-size: 36px;
  font-family: "Robot", sans-serif;
  white-space: nowrap;
}

.logo-3-shadow {
  top: 88px;
  left: 104px;
  color: #008dc3;
}

.logo-3 {
  top: 86px;
  left: 102px;
  background: linear-gradient(#fff 0%, #fff 25%, #008dc3);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.logo-3,
.logo-3-shadow {
  span {
    position: absolute;
    background: inherit;
    font-size: 28px;
    &:nth-of-type(1) {
      top: 5px;
      left: -60px;
      transform: rotate(-10deg);
    }
    &:nth-of-type(2) {
      top: 9px;
      left: -44px;
      transform: rotate(3deg);
    }
    &:nth-of-type(3) {
      top: 5px;
      left: -24px;
      transform: rotate(-9deg);
    }
    &:nth-of-type(4) {
      top: 5px;
      left: 91px;
      transform: rotate(-5deg);
    }
    &:nth-of-type(5) {
      top: 6px;
      left: 116px;
    }
    &:nth-of-type(6) {
      top: 4px;
      left: 134px;
      transform: rotate(5deg);
    }
  }
}

.subtitle,
.title {
  position: absolute;
  transform: rotate(-8deg);
}

.title {
  font-size: 11px;
}

.menu.left {
  .title {
    top: 7px;
    left: 3px;
  }
  .subtitle {
    top: 24px;
    left: 6px;
  }
}

.subtitle {
  font-size: 17px;
  line-height: 14px;
}

.top-cookie,
.bottom-cookie {
  position: absolute;
  height: 25px;
  width: 65px;
  border-radius: 100%;
  background-color: #cae48c;
  box-shadow: inset 0px -2px 4px 1px #d4ac6a;
}

.top-cookie {
  top: 55px;
  left: 18px;
}

.bottom-cookie {
  top: 116px;
  left: 18px;
  &::after {
    top: -13px;
    left: 10px;
    height: 8px;
    width: 46px;
    border-radius: 100%;
    box-shadow: 0px 16px 7px 3px #9c855c;
  }
}

.icecream {
  position: absolute;
  top: 80px;
  left: 18px;
  .vanilla,
  .chocolate,
  .strawberry {
    position: absolute;
    height: 40px;
    width: 24px;
    transform: rotate(-36deg);
    border-radius: 6px;
  }
  .vanilla {
    background-color: white;
    box-shadow: -2px 2px #d6d6d6;
  }
  .chocolate {
    left: 20px;
    background-color: #9e4a30;
    box-shadow: -2px 2px #803720;
  }
  .strawberry {
    left: 40px;
    background-color: pink;
    box-shadow: -2px 2px #b1858d;
  }
}

.menu.right {
  * {
    position: absolute;
  }
  .cookies {
    top: 7px;
    left: 3px;
    .subtitle {
      top: 13px;
      left: 6px;
    }
  }
  .icecream {
    top: 60px;
    left: 3px;
    .subtitle {
      top: 13px;
      left: 2px;
      white-space: nowrap;
    }
  }
  .milk {
    top: 98px;
    left: 6px;
    .subtitle {
      top: 13px;
      left: 6px;
    }
  }
}

.shadow {
  position: absolute;
  background-color: #0000005c;
  height: 7px;
  width: 785px;
  top: 442px;
  left: 73px;
  border-radius: 100%;
}

}


</style>



// WEBPACK FOOTER //
// src/components/index.vue